import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { ModalLayout } from 'layouts/ModalLayout/ModalLayout';
import { useActions, useAppDispatch, useAppSelector } from 'hooks';
import { articleActions, articleThunk, notificationThunk } from 'state';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import DatePicker from 'react-date-picker';
import styles from './ArticleModal.module.scss';
import { articleSelect } from 'state/selectors/articleSelectors';
import { Warning } from 'assets';

interface IArticleModalProps {
  setArticleModal: (value: boolean) => void;
  isEdit?: boolean;
}

export const ArticleModal = ({ setArticleModal, isEdit }: IArticleModalProps) => {
  const formatDateToString = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const normalizeDate = (date: Date) => {
    const normalized = new Date(date);
    normalized.setHours(0, 0, 0, 0);
    return normalized;
  };

  const getTodayDate = () => {
    return normalizeDate(new Date());
  };

  const [bodyMessage, setBodyMessage] = useState('');
  const [bodyMessageArabic, setBodyMessageArabic] = useState('');
  const [isEnglish, setIsEnglish] = useState(true);
  const { createArticle, updateArticle } = useActions(articleThunk);
  const [value, onChange] = useState<any>(getTodayDate());
  const article: any = useAppSelector(articleSelect);
  const dispatch = useAppDispatch();
  const [isWarning, setWarning] = useState(false);
  const [isWarningArabic, setWarningArabic] = useState(false);

  useEffect(() => {
    if (article) {
      setBodyMessage(article.contentEnglish);
      setBodyMessageArabic(article.contentArabic);
    }
  }, [article]);

  const handleDateChange = (date: any) => {
    if (date && date instanceof Date) {
      onChange(normalizeDate(date));
    } else {
      onChange(date);
    }
  };

  const handleAdd = () => {
    const isArabic = /^[\u0600-\u06FF\u0660-\u0669\u0030-\u0039\s!@#\$%\^\&*\)\(+=._-]+$/;

    console.log('time');
    console.log(value);


    if (!bodyMessage || !bodyMessageArabic || !value) {
      setWarning(true);
      return;
    } else {
      setWarning(false);
    }

    if (!isArabic.test(bodyMessageArabic)) {
      setWarningArabic(true);
      return;
    }

    const data = {
      publishingDate: formatDateToString(value),
      contentEnglish: bodyMessage,
      contentArabic: bodyMessageArabic,
    };

    console.log('final data')
    console.log(data)

    setBodyMessage('');
    setBodyMessageArabic('');
    isEdit ? updateArticle({ id: article.id, data }) : createArticle(data);
    setArticleModal(false);
    dispatch(articleActions.clearArticle());
  };

  const handleClose = () => {
    setArticleModal(false);
    setBodyMessage('');
    setBodyMessageArabic('');
    dispatch(articleActions.clearArticle());
  };

  const handleChangeLanguage = () => {
    setIsEnglish(!isEnglish);
  };

  return (
    <ModalLayout handleClose={handleClose} title={'Add new reminder'}>
      <div className={styles.radiobuttonContainer}>
        <button
          type="button"
          // `aria-pressed` rather than a bare button: these two are a pair
          // showing which language the body below is being written in, and
          // without it a screen reader announces two identical buttons with no
          // way to tell which one is currently active.
          aria-pressed={isEnglish}
          onClick={handleChangeLanguage}
          className={isEnglish ? styles.checkedLanguage : styles.uncheckedLanguage}
        >
          English
        </button>
        <button
          type="button"
          aria-pressed={!isEnglish}
          onClick={handleChangeLanguage}
          className={!isEnglish ? styles.checkedLanguage : styles.uncheckedLanguage}
        >
          Arabic
        </button>
      </div>

      <div>
        <p>Publishing date</p>
        <DatePicker
          minDate={getTodayDate()}
          onChange={handleDateChange}
          value={value}
        />
      </div>
      <div>
        <p>Content</p>
        <textarea
          maxLength={200}
          className={styles.notificationModalTextarea}
          value={isEnglish ? bodyMessage : bodyMessageArabic}
          onChange={(e: any) => {
            isEnglish
              ? setBodyMessage(e.target.value)
              : setBodyMessageArabic(e.target.value);
          }}
        />
      </div>

      {isWarning && (
        <div className={styles.warningContainer}>
          <Warning />
          <div className={styles.warningText}>
            Both languages and publishing date ​​must be filled in
          </div>
        </div>
      )}

      {isWarningArabic && (
        <div className={styles.warningContainer}>
          <Warning />
          <div className={styles.warningText}>The message must be in Arabic</div>
        </div>
      )}

      <button type="button" className={styles.buttonDark} onClick={handleAdd}>
        {isEdit ? 'Save' : 'Add'}
      </button>
    </ModalLayout>
  );
};
